import React from 'react'

function BuyProduct() {
  return (
    <div>
      
    </div>
  )
}

export default BuyProduct
